<template>
  <div class="formselect">
    <div class="checktitle">
      {{property.name}}
      <span v-if="property.checked" class="ischeck">*</span>
    </div>
    <div class="formselectbox">
      <div class="leftformbd">
      <div class="leftforminput">请选择</div>
    </div>
    <i class="el-icon-arrow-down"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>

